import { withI18n } from 'react-i18next';
import PayInvoiceRow from './PayInvoiceRow';

export const pureComponent = PayInvoiceRow;
export default withI18n()(PayInvoiceRow);
